'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _deepmerge = require('deepmerge'),
    _deepmerge2 = _interopRequireDefault(_deepmerge);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var createTransitions = function createTransitions(options) {
  return (0, _deepmerge2.default)({
    easing: {
      easeIn: 'ease-in',
      easeOut: 'ease-out'
    },
    duration: {
      shortest: '100ms',
      short: '250ms',
      enteringScreen: '250ms',
      leavingScreen: '250ms'
    }
  }, options);
};

exports.default = createTransitions;